import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { fonts, colors, media } from 'shared/lib'

const Box = styled.div`
  background-color: ${colors.FC2_WHITE};
  margin: 10px 0;
  padding: 20px;
  ${media.large`
    margin: 20px;
    padding: 0 0 20px;
    border-bottom: 1px solid ${colors.FC2_LIGHTEST_GREY};
  `}
`

const Title = styled.div`
  margin: 0 0 20px;
  padding: 0 0 20px;
  ${fonts.SUBTITLE_3}
  border-bottom: 1px solid ${colors.FC2_LIGHTEST_GREY};
  ${media.large`
    ${fonts.SUBTITLE_2}
    margin: 20px 0;
    padding: 0;
    border-bottom: none;
    text-transform: none;
  `}
`

interface IEditSection {
  title: ReactNode
  children: ReactNode
  qaAttr?: string
}

const EditSection: FC<IEditSection> = ({ title, children, qaAttr }) => {
  return (
    <Box>
      <Title data-qa={`${qaAttr}Header`}>{title}</Title>
      {children}
    </Box>
  )
}

export default EditSection
